var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47162 7.47113C3.17678 7.76598 3.17678 8.24402 3.47162 8.53887L11.4716 16.5389C11.7665 16.8337 12.2445 16.8337 12.5394 16.5389L20.5394 8.53887C20.8342 8.24402 20.8342 7.76598 20.5394 7.47113C20.2445 7.17629 19.7665 7.17629 19.4716 7.47113L12.0055 14.9373L4.53935 7.47113C4.24451 7.17629 3.76647 7.17629 3.47162 7.47113Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.7af12c98e518d64d02ba5fda63430c1e.svg";
export { ForwardRef as ReactComponent };